import omit from 'lodash/omit';
import { createContext, ReactNode, useContext, useState } from 'react';
import { Helmet } from 'react-helmet';

export type OrderedModal = { modal: React.JSX.Element; order: number };
export type Modals = Record<string, OrderedModal>;

type ModalContext = {
  showModal: (modal: React.JSX.Element, key: string) => void;
  hideModal: (key: string) => void;
};
const ModalContext = createContext<ModalContext>({
  showModal: () => {},
  hideModal: () => {},
});

export const ModalContextProvider = ({ children }: { children?: ReactNode }) => {
  const [modals, setModals] = useState<Modals>({});

  const contextValue = {
    showModal: (modal: React.JSX.Element, key: string) => {
      setTimeout(() => {
        const entry = { modal, order: Object.keys(modals).length };
        setModals({ [key]: entry, ...modals });
      });
    },
    hideModal: (key: string) => setModals(omit(modals, key)),
  };

  return (
    <ModalContext.Provider value={contextValue}>
      <Helmet bodyAttributes={{ class: Object.keys(modals).length > 0 ? 'no-scroll' : undefined }} />

      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext<ModalContext>(ModalContext);
